"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("../index.scss");
const common_1 = require("@Const/common");
const mobx_react_1 = require("mobx-react");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const removers_1 = require("@App/helpers/work-entities/removers");
const permission_1 = require("@App/helpers/permission");
const contexts_1 = require("@App/contexts");
const WriterLabels_1 = __importDefault(require("./WriterLabels"));
const WriterSideBar_1 = __importDefault(require("./WriterSideBar"));
const OriginalPublisherCardAddWriters = (props) => {
    const { data, removeFunc } = props;
    const { workStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    const [workWriters, setWorkWriters] = (0, react_1.useState)([]);
    const removeWriter = (removingWriter) => {
        const workDraftFromLocal = workStore.workDraftLocal;
        const editingOPId = data.localId;
        if (!workDraftFromLocal || !editingOPId || !removingWriter) {
            return;
        }
        const originalPublishers = workDraftFromLocal.originalPublishers;
        const indexOfOP = originalPublishers.map((op) => op.localId).indexOf(editingOPId);
        const updatedWriters = data.writers.filter((writer) => {
            if (removingWriter.localId === writer.localId) {
                return;
            }
            return writer;
        });
        const updatedOriginalPublisher = {
            id: data.id,
            amend: data.amend,
            localId: editingOPId,
            publisherName: data.publisherName,
            ipiNumber: data.ipiNumber,
            publisherShare: data.publisherShare,
            administratorPublishers: data.administratorPublishers,
            writers: updatedWriters,
        };
        const updatedOPArray = (0, removers_1.setItemToArrayByIndex)(originalPublishers, +indexOfOP, updatedOriginalPublisher);
        const updatedWorkDraft = Object.assign(Object.assign({}, workDraftFromLocal), { originalPublishers: updatedOPArray });
        workStore.setWorkDraftToLocal(updatedWorkDraft);
        const newWorkWriters = [...workWriters, removingWriter];
        setWorkWriters(newWorkWriters);
    };
    return (react_1.default.createElement("div", { className: 'original-publisher-card' },
        react_1.default.createElement("div", { className: 'head' },
            react_1.default.createElement("p", { className: 'bold' }, data.publisherName),
            react_1.default.createElement("div", { className: 'controls' }, removeFunc && (react_1.default.createElement("span", { className: 'small-2 medium', onClick: () => removeFunc(data) }, "Remove")))),
        react_1.default.createElement("div", { className: 'content' },
            react_1.default.createElement("p", { className: 'small' },
                "IPI: ",
                react_1.default.createElement("strong", null, data.ipiNumber)),
            !data.administratorPublishers.length && data.publisherShare !== null && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", { className: 'small' }, "Publisher share:"),
                react_1.default.createElement("h1", { className: 'percent' }, data.publisherShare ? data.publisherShare : 0))),
            react_1.default.createElement("p", { className: 'small' }, "Represented Writers:"),
            react_1.default.createElement("div", { className: 'represented-writers-container' },
                (0, permission_1.canAmend)(data.amend) && (react_1.default.createElement("div", { className: 'item add', onClick: () => setSidebarIsOpen(true) },
                    react_1.default.createElement("p", { className: 'bold small-2' }, "Add writer"),
                    react_1.default.createElement("div", { className: 'button' },
                        react_1.default.createElement("img", { src: common_1.ICONS.add, alt: "add" })))),
                react_1.default.createElement(WriterLabels_1.default, { linkedWriters: data.writers, isAmendable: (0, permission_1.canAmend)(data.amend), removeWriter: removeWriter }))),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarIsOpen, onClose: () => setSidebarIsOpen(false) },
            react_1.default.createElement(WriterSideBar_1.default, { data: data }))));
};
exports.default = (0, mobx_react_1.observer)(OriginalPublisherCardAddWriters);
